/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.5 4.5C13.5 6.9853 11.4853 9 9 9S4.5 6.9853 4.5 4.5 6.5147 0 9 0s4.5 2.0147 4.5 4.5Zm-1.5 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.6568 1.3431-3 3-3s3 1.3432 3 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M0 21v-.75c0-5.322 3.9693-9.75 9-9.75.757 0 1.493.1014 2.1966.2925a.75.75 0 0 1-.3932 1.4475A6.8692 6.8692 0 0 0 9 12c-3.8584 0-7.1225 3.2439-7.4688 7.5H9A.75.75 0 0 1 9 21H0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2627 18.9699C14.7127 19.6011 13.9029 20 13 20c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3c.8005 0 1.5278.3135 2.0657.8245l3.0729-1.9206A2.999 2.999 0 0 1 18 12c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3a2.9895 2.9895 0 0 1-2.0657-.8245l-3.0729 1.9206c.09.2852.1386.5889.1386.9039 0 .2156-.0227.4258-.0659.6285l2.8032 1.4016C19.2873 18.3989 20.0971 18 21 18c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3c0-.2156.0227-.4258.0659-.6285l-2.8032-1.4016Zm-.8714-1.4083A1.4952 1.4952 0 0 0 14.5 17c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5c.5447 0 1.0215-.2903 1.2843-.7246a.7566.7566 0 0 1 .107-.2138Zm5.2174 2.8768A1.4952 1.4952 0 0 0 19.5 21c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5c-.5447 0-1.0215.2903-1.2843.7246a.7566.7566 0 0 1-.107.2138ZM22.5 12c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Share'
);
